module.exports = __webpack_public_path__ + "img/cyberboard_r1.e37acb25.jpg";